import { MARQUEE_ITEMS } from "../constants";

const Row = () => (
    <div className="flex shrink-0 items-center">
        {MARQUEE_ITEMS.map((item, i) => (
            <span key={i} className="flex items-center">
                <span className="font-display italic font-medium text-2xl sm:text-4xl text-[#0B5CF5]/25 whitespace-nowrap px-6 sm:px-10">
                    {item}
                </span>
                <span className="w-1.5 h-1.5 rounded-full bg-[#0B5CF5]/30" />
            </span>
        ))}
    </div>
);

const Marquee = () => (
    <section className="py-10 sm:py-14 bg-white border-y border-slate-100 overflow-hidden" data-testid="editorial-marquee" aria-hidden="true">
        <div className="marquee-track">
            <Row />
            <Row />
        </div>
    </section>
);

export default Marquee;
